/**
 * Font size that keeps a label on ONE line inside a fixed-width control.
 *
 * Pill buttons carry user/venue-supplied text ("Carmela Coffee - West Village"),
 * which is unbounded — a long one wrapped to two lines and broke the row's
 * geometry (device pass, 2026-08-15). Shrinking to fit is the right answer for
 * a NAME: truncating "Carmela Coffee - West Vill…" hides the part that tells
 * you which place it is, and wrapping changes the control's height.
 *
 * Character-count based rather than measured, deliberately: measurement means a
 * layout read and a second paint, and this runs on the exchange hot path. The
 * ~0.55em average advance width for the UI font is close enough for pill
 * labels, and the floor guarantees legibility even when the estimate is off.
 *
 * @param {string} text
 * @param {Object} [opts]
 * @param {number} [opts.width]  - usable px width inside the control
 * @param {number} [opts.max]    - preferred size when it fits
 * @param {number} [opts.min]    - never go below this
 * @returns {number} font size in px
 */
export const fitTextSize = (text, { width = 224, max = 16, min = 12 } = {}) => {
  const length = (text || '').length;
  if (!length) return max;

  // Average glyph advance ≈ 0.55em for the system UI stack at these weights.
  const estimated = Math.floor(width / (length * 0.55));
  return Math.max(min, Math.min(max, estimated));
};
